import Modal from './Modal'
export  default  Modal



// WEBPACK FOOTER //
// ./components/Cc-Modal/index.js